import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { formatFullDate } from "@seabrookstudios/pitch2table-core";
import { useNavigate } from "react-router-dom";
import { Path } from "../Path";
import { useInboxMessageIdFromRoute } from "./WithInboxMessageIdFromRoute";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").InboundEmail} props.item
 */
export const InboxMessageListEntry = ({ item }) => {
  const messageId = useInboxMessageIdFromRoute();
  const navigate = useNavigate();
  const selected = messageId === item.id;

  const from = item.from || item.originalFrom || "Unknown sender";
  const secondary = `${from} · ${formatFullDate(item.receivedAt)}`;

  const onClickHandler = () => {
    navigate(Path.inbox().message(item.id));
  };

  return (
    <ListItemButton alignItems="flex-start" selected={selected} onClick={onClickHandler}>
      <ListItemText
        primary={item.subject || "(no subject)"}
        secondary={secondary}
        primaryTypographyProps={{ noWrap: true }}
        secondaryTypographyProps={{ noWrap: true }}
      />
    </ListItemButton>
  );
};
